import { Injectable } from '@angular/core';
import { L10N_EN } from '../l10n/messages-en';
import { L10N_SK } from '../l10n/messages-sk';
import { L10N_CS } from '../l10n/messages-cs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class L10nService {

  private messages = {
    en: L10N_EN,
    sk: L10N_SK,
    cs: L10N_CS
  };

  constructor() {
  }

  public get(key: string, params?: any[]): string {
    let value = this.messages[environment.locale][key];
    if (! value) {
      console.error('Unknown localization key: ' + key);
      return key;
    }
    if (params) {
      if (! (params instanceof Array)) {
        params = [params];
      }
      for (let i = 0; i < params.length; i++) {
        let paramValue = String(params[i]);
        if (paramValue && paramValue.substr(0, 1) === '#') {
          paramValue = this.get(paramValue.substr(1));
        }
        value = value.replace('{' + i + '}', paramValue);
      }
    }
    return value;
  }
}
